<div [attr.data-testid]="activeMenu === menuEnum.BroadcastMessageOperators ? 'comms-broadcast-operators' : null">
	<div>
		<broadcast-message
			[_feedbackMenuActive]="getFeedbackMenuItem(activeMenu)"
			*ngIf="
				[
					menuEnum.BroadcastMessageOperators,
					menuEnum.BroadcastMessageDrivers,
					menuEnum.BroadcastMessageCustomers
				].includes(activeMenu)
			"
			[menuPermissionActive]="menuPermissionActive"
		></broadcast-message>
		<!-- <user-feedback *ngIf="activeMenu === menuEnum.Feedbacks" [menuPermissionActive]="menuPermissionActive"></user-feedback> -->
	</div>
</div>
